var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVegetables(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2087.05,
    y1: -4973.56,
    x2: -1843.64,
    y2: -5255.61,
    gradientTransform: "translate(41.72 -1049.69) rotate(180) scale(0.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a4",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vegetables") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.44,
    y: 0.53,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "veggies"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.57,427.13c5.68.19,14.2,5.25,30.93,3.52,24.87-2.57,58.45-29.49,76.84-63.86,56.89-106.34,17.83-173.5-19.36-188.72s-66.62,2.1-90.15,2.1-53-17.32-90.16-2.1-76.25,82.38-19.35,188.72c19.32,36.11,46.76,57.12,81.66,63.47C375.68,432.58,386.07,426.91,392.57,427.13Z",
    style: {
      fill: "#ff7b82",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.2,423c-7.92,4.25-15.64,6.93-22.69,7.67-16.73,1.74-25.26-3.34-30.95-3.53-6.49-.21-16.87,5.46-29.59,3.15-34.88-6.36-62.33-27.38-81.65-63.48-51.89-97-24-161.37,9.56-183.5a248.41,248.41,0,0,0-12.86,51c-2.66,19.77-12.1,89.85,36.53,142.06C358.73,423.78,421.2,424.66,446.2,423Z",
    style: {
      fill: "#ef5e6c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,217.32c-25.14-.68-40.9-22.69,0-23C420,194,415.87,218.23,381.86,217.32Z",
    style: {
      fill: "#ef5e6c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.64,201.43a23.18,23.18,0,0,1-3.17,6.59c-.4.52-1,1.22-1.71,1.18-3.58-.26.37-19.24-8.52-34.71-7.6-13.19-18.71-14-19.41-24.15a15.83,15.83,0,0,1,3.51-10.88,15.1,15.1,0,0,0-.34,4.27c.68,10.15,11.79,11,19.38,24.15,8.9,15.48,4.95,34.46,8.55,34.71C387.64,202.63,388.22,202,388.64,201.43Z",
    style: {
      fill: "#754c24",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.66,201.39a0,0,0,0,0,0,0v0c-.42.53-1,1.2-1.71,1.16-3.6-.25.35-19.23-8.55-34.71-7.59-13.19-18.7-14-19.38-24.15a15.1,15.1,0,0,1,.34-4.27,7,7,0,0,1,3.61-2.4c8.28-1.89,20.28,18.31,25,34.65C391.81,184.93,390.73,195,388.66,201.39Z",
    style: {
      fill: "#8c6239",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.08,255c-9,6.56-23.36,2.24-32-9.61s-8.37-26.85.61-33.4,23.35-2.24,32,9.61S510.06,248.49,501.08,255Z",
    style: {
      fill: "#f9bbc6",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "cucumber"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.57,612.79C450.5,723.05,673.16,798.83,758,891.85c87.36,47.49,166.17-75.66,98.65-125.9C829.38,759,552,541.68,503.56,612.79",
    style: {
      fill: "#217821"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.62,903.53c76.46,7.14,132.21-83,76.25-136.81-92.29-33.87-142.78,116.59-76.25,136.81Z",
    style: {
      fill: "#c6e9af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861,768.14c-22.34-4.28-51.52-4.39-68.67,6.9L513.94,602.4c85.43-21,235.21,108.67,340.07,160.31",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.47,771.17C777.59,740.28,714,880.7,787.77,899.77,882.45,891.52,894.08,809.18,857.47,771.17Zm2.34-3.77c-89.06-38.64-147.91,117.9-73.19,137.06C880.05,903.65,906.25,801.45,859.81,767.4Z",
    style: {
      fill: "#aade87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.63,767.81a59.29,59.29,0,0,0-25.5,5.08c-11.91,5-21.92,13.42-30.29,23.08a103.37,103.37,0,0,0-21.44,41.62c-2.36,10.08-3.08,20.7-.85,30.86,2.46,10.84,9.35,20.7,19.2,25.95,3.79,1.9,7.81,4,12.06,4.19a119.17,119.17,0,0,0,43.79-11.75c15.37-7.45,28.57-19.62,35.94-35.14,12.69-25.56,8.3-58.85-11.52-79.61a59,59,0,0,0-21.39-4.28Z",
    style: {
      fill: "#c6e9af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.63,803.25C802.24,804.41,794,809,796.73,823l16.07.46,1.83-20.19",
    style: {
      fill: "#87de87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.82,826A65.46,65.46,0,0,0,839,806.7a26.65,26.65,0,0,0-18.36-6c-2.87,7.45-3.24,16-1.83,25.24",
    style: {
      fill: "#87de87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.85,831.24c5.21,5.93,11.48,7.62,17.9,8.72,1.6-7.84,2-15.87,0-24.32a86.3,86.3,0,0,0-17.9,15.6",
    style: {
      fill: "#87de87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809,831.94a124,124,0,0,1-20.65,18.81c-.25-8.66,1-16.88,5-24.32q10.5-.31,15.6,5.51",
    style: {
      fill: "#87de87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.86,859c9.8,4.87,12.16-4.09,8-16.52C799.84,845.31,787.82,857.62,801.86,859Z",
    style: {
      fill: "#87de87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.1,847.53c-7.72,8.53-15.45,10.16-23.17,12.16a73.16,73.16,0,0,1,3.67-21.11",
    style: {
      fill: "#87de87"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "raspberry"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M812,551.79a16.57,16.57,0,1,1-19.12-14l.38-.06A16.56,16.56,0,0,1,812,551.79Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812,551.79a16.56,16.56,0,0,1-8.25,16.75l-.36.06a16.57,16.57,0,0,1-10.51-30.81l.38-.06A16.56,16.56,0,0,1,812,551.79Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.12,543.81a16.55,16.55,0,0,1-8.24,16.75,16.32,16.32,0,0,1-5.82,2,16.56,16.56,0,0,1-5-32.73l.37-.06A16.56,16.56,0,0,1,833.12,543.81Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.12,543.81a16.55,16.55,0,0,1-8.24,16.75l-.37.06A16.56,16.56,0,0,1,814,529.81l.37-.06A16.56,16.56,0,0,1,833.12,543.81Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852,549.87a16.56,16.56,0,1,1-19.11-14c.12,0,.25,0,.38-.06A16.56,16.56,0,0,1,852,549.87Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852,549.87a16.55,16.55,0,0,1-8.24,16.75l-.37.06a16.56,16.56,0,0,1-10.5-30.81c.12,0,.25,0,.38-.06A16.56,16.56,0,0,1,852,549.87Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.11,568.44a16.56,16.56,0,0,1-10.21,15.63,16.73,16.73,0,0,1-6,1.26,16.56,16.56,0,0,1-1-33.11h.39A16.56,16.56,0,0,1,863.11,568.44Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.11,568.44a16.56,16.56,0,0,1-10.21,15.63h-.38a16.57,16.57,0,0,1-6.68-31.86h.39A16.56,16.56,0,0,1,863.11,568.44Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.63,600.67a16.56,16.56,0,1,1-16.94-16.55h.38A16.56,16.56,0,0,1,794.63,600.67Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.63,600.67a16.56,16.56,0,0,1-10.52,15.43h-.37a16.56,16.56,0,0,1-6-32h.38A16.56,16.56,0,0,1,794.63,600.67Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.15,603.66A16.54,16.54,0,0,1,810,621.28a16.36,16.36,0,0,1-5.54,2.66,16.56,16.56,0,0,1-8.94-31.89l.37-.1A16.55,16.55,0,0,1,816.15,603.66Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.15,603.66A16.54,16.54,0,0,1,810,621.28l-.36.1a16.57,16.57,0,0,1-14.12-29.33l.37-.1A16.55,16.55,0,0,1,816.15,603.66Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.64,607.3a16.56,16.56,0,1,1-22.39-7.73l.34-.16A16.56,16.56,0,0,1,842.64,607.3Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.64,607.3a16.56,16.56,0,0,1-2.91,18.44l-.34.16a16.56,16.56,0,0,1-19.14-26.33l.34-.16A16.56,16.56,0,0,1,842.64,607.3Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.82,596.7a16.57,16.57,0,0,1-2.92,18.45,16.39,16.39,0,0,1-5,3.61A16.56,16.56,0,0,1,847.42,589l.35-.16A16.56,16.56,0,0,1,869.82,596.7Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.82,596.7a16.57,16.57,0,0,1-2.92,18.45l-.33.16A16.57,16.57,0,0,1,847.42,589l.35-.16A16.56,16.56,0,0,1,869.82,596.7Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800,571.51a16.57,16.57,0,1,1-19.12-14l.38-.06A16.58,16.58,0,0,1,800,571.51Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800,571.51a16.57,16.57,0,0,1-8.25,16.76l-.37.06a16.57,16.57,0,0,1-10.5-30.82l.38-.06A16.58,16.58,0,0,1,800,571.51Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.39,580.81a16.56,16.56,0,1,1-19.11-14l.38-.06A16.56,16.56,0,0,1,817.39,580.81Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.39,580.81a16.57,16.57,0,0,1-8.24,16.76l-.37.06a16.57,16.57,0,0,1-10.5-30.82l.38-.06A16.56,16.56,0,0,1,817.39,580.81Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.89,585.64a16.57,16.57,0,0,0-21.28-9.8l-.36.14a16.57,16.57,0,1,0,21.64,9.66Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.24,581.71a16.56,16.56,0,0,0-18.73-14.06c-.13,0-.26,0-.38.06a16.56,16.56,0,1,0,19.11,14Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.82,560.37a16.56,16.56,0,1,1-19.11-14l.38-.06A16.57,16.57,0,0,1,829.82,560.37Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.82,560.37a16.57,16.57,0,0,1-8.24,16.76l-.37.06a16.57,16.57,0,0,1-10.5-30.82l.38-.06A16.57,16.57,0,0,1,829.82,560.37Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852,561.32a16.57,16.57,0,0,0-18.73-14.06l-.38.06a16.57,16.57,0,1,0,19.11,14Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.94,568.08c-.38-.73-1.33-1-2.05-1.38a18,18,0,0,0-2-.8,7.9,7.9,0,0,0-.32-5.34.39.39,0,0,0-.7.09,20.49,20.49,0,0,0-.19,2.72,15.3,15.3,0,0,0,0,2.62.81.81,0,0,0,.15,1.32c.75.37,1.52.71,2.26,1.09a4.77,4.77,0,0,0,2.17.91A.83.83,0,0,0,856.94,568.08Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.66,605.06a41.88,41.88,0,0,0-4.66,1,21.64,21.64,0,0,1-5.45.2,14.12,14.12,0,0,1-8.32-3.53,12.68,12.68,0,0,1-4-7.24c-.66-4.06.61-7.52,1.77-11.32a.81.81,0,0,0-1.48-.63c-2.06,3.54-3.9,8.25-3.54,12.39a14.31,14.31,0,0,0,4.74,9.33,17.67,17.67,0,0,0,9.88,4.47c3.73.46,9,0,11.91-2.63A1.18,1.18,0,0,0,833.66,605.06Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.49,598.54c-1.55-1.37-3.49-2.1-5-3.57a9.07,9.07,0,0,1-2.83-6.1,18.89,18.89,0,0,1,3.21-12c.37-.61-.43-1.09-.92-.71a13.87,13.87,0,0,0-2.36,2.42,1,1,0,0,0-.45-.18,25.63,25.63,0,0,0-3.71.14,14,14,0,0,1-4.21-.62,14.89,14.89,0,0,1-7-4.36,15.35,15.35,0,0,1-3.63-7.69c-.47-3.14.22-5.9,1-8.91a1,1,0,0,0-1.82-.77c-3.32,5.61-1.84,14,2.11,18.87a17.42,17.42,0,0,0,8,5.47c2.18.74,5.54,1.42,8.06.74a17,17,0,0,0-1.71,9.35,11.46,11.46,0,0,0,3.59,7.1c1.85,1.8,4.35,3.86,7.08,3.26A1.44,1.44,0,0,0,848.49,598.54Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.62,543.16c-1.25-1.23-3.69-2.76-5.41-1.65a.87.87,0,0,0-.17,1.35c1.11,1,2.59,1.09,3.64,2.24a5.09,5.09,0,0,1,1.07,1.77c.29.86.25,1.42,1,2a1.18,1.18,0,0,0,1.42-.18C848.61,547.16,846.84,544.34,845.62,543.16Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.08,579.29a6,6,0,0,0-3.86-4.15c-.59-.2-1.24.58-.85,1.11a13.41,13.41,0,0,1,2.43,5c.35,1.7,0,3.59,1.09,5a1,1,0,0,0,1.51-.19C866.58,584.33,865.72,581.11,865.08,579.29Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.47,533.88a3.62,3.62,0,0,0-2.29-1.56c-.86-.16-2.12.06-2.37,1a.71.71,0,0,0,.38,1.06,3.47,3.47,0,0,0,1.14.44,1.32,1.32,0,0,1,.72.47,1.4,1.4,0,1,0,2.42-1.41Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.84,558.42c-.59-3.81-4.58-7-8.51-6a3.87,3.87,0,0,0-3,4.3,3.43,3.43,0,0,0,1.12,2.08,4,4,0,0,0,2.07.67,3.75,3.75,0,0,1,1.17,1c1.15,1.61.33,3.85,1.57,5.39a3,3,0,0,0,4.73-.36C846.16,563.7,846.15,560.44,845.84,558.42Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.58,587.66a1.36,1.36,0,0,0-.47.12.92.92,0,0,0-.7.38,1,1,0,0,0,.08,1.32l.07.09a1.12,1.12,0,0,0,.16.28l.15.17.11.23s.1.35.1.34,0,.37,0,.51a1.24,1.24,0,0,0,1.08,1.23,1.26,1.26,0,0,0,1.37-.89C829.9,590.12,829.37,587.56,827.58,587.66Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867,598.57a1.49,1.49,0,0,0-1.4-.89,1.34,1.34,0,0,0-.91.38,1.27,1.27,0,0,0-.36.73,1.41,1.41,0,0,0-.07,1.46,1.68,1.68,0,0,0,1.95.75,1.37,1.37,0,0,0,1-1A2.32,2.32,0,0,0,867,598.57Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.77,549.49a2.63,2.63,0,0,0-3.95,1,1.09,1.09,0,0,0,.75,1.41,1.58,1.58,0,0,0,.84.64,6.9,6.9,0,0,0,.33.9,2.43,2.43,0,0,0,1.65,1.38,1.57,1.57,0,0,0,1.91-1.08A4,4,0,0,0,817.77,549.49Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.25,540.61a.89.89,0,0,0-1.13.44l0,0a0,0,0,0,1,0,0h0a.43.43,0,0,0,.27.57,1,1,0,0,0,.21.1l.13,0h0l.1.06h0a1.12,1.12,0,0,0,.28.25.62.62,0,0,0,.93-.53A1.1,1.1,0,0,0,797.25,540.61Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.31,559.84a4,4,0,0,0-3.4-1.76,1.24,1.24,0,0,0-.62,2.29,4.25,4.25,0,0,1,1.68,1.55c.46.82.54,1.83,1.07,2.59a1.52,1.52,0,0,0,2.8-.75A6.86,6.86,0,0,0,859.31,559.84Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.39,554.4a1.32,1.32,0,0,0-.2,1.55,3.32,3.32,0,0,0,1,1l.5.22c-.16-.07-.14-.06,0,0l.29.19.3.3.1.08a.22.22,0,0,0,0,.1c0,.07.24.49.11.19a2.91,2.91,0,0,0,.65,1.11,1.82,1.82,0,0,0,3-.79C845.05,555.79,840.49,552,838.39,554.4Z",
    style: {
      fill: "#f9d2dd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "raspberry-2",
    "data-name": "raspberry"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.37,509.91a16.56,16.56,0,1,1-9.84-21.55l.36.13A16.56,16.56,0,0,1,709.37,509.91Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.37,509.91A16.57,16.57,0,0,1,694,520.51l-.35-.13a16.57,16.57,0,0,1,5.88-32l.36.13A16.56,16.56,0,0,1,709.37,509.91Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.75,513.28a16.57,16.57,0,1,1-9.85-21.55l.36.13A16.57,16.57,0,0,1,731.75,513.28Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.75,513.28a16.58,16.58,0,0,1-15.37,10.6l-.36-.13a16.57,16.57,0,0,1,5.88-32l.36.13A16.57,16.57,0,0,1,731.75,513.28Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.29,527.8a16.56,16.56,0,1,1-9.84-21.55l.36.13A16.56,16.56,0,0,1,745.29,527.8Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.29,527.8a16.56,16.56,0,0,1-15.37,10.6l-.35-.13a16.57,16.57,0,0,1,5.88-32l.36.13A16.56,16.56,0,0,1,745.29,527.8Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.9,549.42a16.56,16.56,0,1,1-7.15-22.59l.34.18A16.56,16.56,0,0,1,745.9,549.42Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.9,549.42a16.55,16.55,0,0,1-16.54,8.65l-.34-.17a16.57,16.57,0,0,1,9.73-31.07l.34.18A16.56,16.56,0,0,1,745.9,549.42Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.4,544.12a16.56,16.56,0,1,1-6.7-22.72l.33.18A16.56,16.56,0,0,1,670.4,544.12Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.4,544.12a16.57,16.57,0,0,1-16.71,8.33l-.33-.18A16.57,16.57,0,0,1,663.7,521.4l.33.18A16.56,16.56,0,0,1,670.4,544.12Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.72,557.23A16.56,16.56,0,1,1,675.37,537l.37.09A16.55,16.55,0,0,1,687.72,557.23Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.72,557.23a16.57,16.57,0,0,1-14,12.37l-.36-.09a16.56,16.56,0,0,1,2-32.49l.37.09A16.55,16.55,0,0,1,687.72,557.23Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.07,573.33a16.56,16.56,0,1,1-15.78-17.67l.38,0A16.57,16.57,0,0,1,709.07,573.33Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.07,573.33A16.58,16.58,0,0,1,697.52,588l-.37,0a16.57,16.57,0,0,1-3.86-32.33l.38,0A16.57,16.57,0,0,1,709.07,573.33Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738,577.36a16.56,16.56,0,1,1-15.78-17.67l.38,0A16.56,16.56,0,0,1,738,577.36Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738,577.36A16.57,16.57,0,0,1,726.41,592l-.37,0a16.56,16.56,0,0,1-3.86-32.32l.38,0A16.56,16.56,0,0,1,738,577.36Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.34,521.3a16.56,16.56,0,1,1-9.84-21.55l.35.14A16.56,16.56,0,0,1,689.34,521.3Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.34,521.3A16.55,16.55,0,0,1,674,531.9l-.35-.13a16.57,16.57,0,0,1,5.88-32l.35.14A16.56,16.56,0,0,1,689.34,521.3Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700,537.9a16.56,16.56,0,1,1-9.84-21.55l.35.13A16.57,16.57,0,0,1,700,537.9Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700,537.9a16.57,16.57,0,0,1-15.37,10.6l-.35-.13a16.57,16.57,0,0,1,5.88-32l.35.13A16.57,16.57,0,0,1,700,537.9Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719,554.06a16.56,16.56,0,0,0-13.79-18.93l-.38,0a16.56,16.56,0,1,0,14.17,19Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.77,564a16.56,16.56,0,0,0-9.48-21.42l-.36-.13A16.57,16.57,0,1,0,744.77,564Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.78,526.13a16.55,16.55,0,0,1-15.37,10.59,16.25,16.25,0,0,1-6-1.11,16.56,16.56,0,0,1,11.57-31l.36.13A16.56,16.56,0,0,1,720.78,526.13Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.78,526.13a16.55,16.55,0,0,1-15.37,10.59l-.35-.13a16.56,16.56,0,0,1,5.88-32l.36.13A16.56,16.56,0,0,1,720.78,526.13Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.7,537.79a16.55,16.55,0,0,0-9.48-21.41l-.36-.13a16.56,16.56,0,0,0-11.57,31,16.25,16.25,0,0,0,6,1.11A16.54,16.54,0,0,0,739.7,537.79Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.69,546.09c0-.83-.65-1.56-1.12-2.21a16.33,16.33,0,0,0-1.34-1.67,7.89,7.89,0,0,0,2.33-4.81.39.39,0,0,0-.66-.26,17.52,17.52,0,0,0-1.49,2.28,15.54,15.54,0,0,0-1.31,2.27.81.81,0,0,0-.51,1.22c.47.69,1,1.36,1.44,2.06s.74,1.49,1.45,1.85A.83.83,0,0,0,740.69,546.09Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.32,567a43.57,43.57,0,0,0-4.54-1.44,21.56,21.56,0,0,1-4.85-2.48,14.2,14.2,0,0,1-5.54-7.14,12.64,12.64,0,0,1,0-8.28c1.4-3.87,4.2-6.27,7.07-9a.82.82,0,0,0-1-1.27c-3.52,2.08-7.42,5.29-9.14,9.08a14.37,14.37,0,0,0-.41,10.46,17.65,17.65,0,0,0,6.44,8.72c3,2.23,7.86,4.36,11.68,3.52A1.18,1.18,0,0,0,702.32,567Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.45,568.55c-.68-2-2-3.54-2.64-5.57a9.05,9.05,0,0,1,.51-6.7,18.87,18.87,0,0,1,8.67-8.95c.62-.34.16-1.15-.45-1.06a14.4,14.4,0,0,0-3.25,1,.93.93,0,0,0-.3-.37,25.62,25.62,0,0,0-3.3-1.69,14.2,14.2,0,0,1-3.38-2.59,15,15,0,0,1-3.93-7.2,15.26,15.26,0,0,1,.59-8.49c1.11-3,3.07-5,5.19-7.3a1,1,0,0,0-1.22-1.56c-5.63,3.28-8.42,11.31-7.37,17.5a17.5,17.5,0,0,0,4.27,8.66c1.55,1.7,4.15,3.94,6.68,4.57a16.93,16.93,0,0,0-6.06,7.33,11.45,11.45,0,0,0-.33,7.95c.73,2.47,1.91,5.49,4.59,6.31A1.45,1.45,0,0,0,718.45,568.55Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743,518.81c-.5-1.68-1.88-4.21-3.92-4.07a.86.86,0,0,0-.81,1.09c.49,1.39,1.73,2.21,2.08,3.73a5,5,0,0,1,.07,2.07c-.16.89-.47,1.36-.09,2.26a1.18,1.18,0,0,0,1.33.53C743.63,523.77,743.46,520.44,743,518.81Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.32,559.85a6,6,0,0,0-1.34-5.51.77.77,0,0,0-1.29.55,13.43,13.43,0,0,1-.31,5.54c-.52,1.66-1.79,3.12-1.48,4.88a1,1,0,0,0,1.42.57C741.17,565,742,561.74,742.32,559.85Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.92,500.88a3.63,3.63,0,0,0-1.24-2.48c-.67-.56-1.88-1-2.55-.29a.72.72,0,0,0-.2,1.12,3.62,3.62,0,0,0,.79.93,1.26,1.26,0,0,1,.39.77,1.41,1.41,0,0,0,2.81-.05Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.72,532.24c1.34-3.61-.56-8.38-4.5-9.39a3.87,3.87,0,0,0-4.75,2.27,3.37,3.37,0,0,0,0,2.36c.32.83.93,1.12,1.48,1.59a3.77,3.77,0,0,1,.55,1.43c.22,2-1.59,3.52-1.26,5.46a3,3,0,0,0,4.3,2C733.42,537,735,534.16,735.72,532.24Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.51,548.85a1.42,1.42,0,0,0-.47-.13.93.93,0,0,0-.8,0,1,1,0,0,0-.58,1.19.52.52,0,0,1,0,.11,1.23,1.23,0,0,0,0,.33,1.72,1.72,0,0,0,0,.22,1.93,1.93,0,0,1,0,.25s-.09.36-.08.35a3.78,3.78,0,0,1-.27.44,1.22,1.22,0,0,0,.35,1.59,1.25,1.25,0,0,0,1.63-.11C706.33,552.13,707.12,549.63,705.51,548.85Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.55,577.58a1.49,1.49,0,0,0-.79-1.45,1.39,1.39,0,0,0-1-.12,1.44,1.44,0,0,0-.67.47,1.42,1.42,0,0,0-.77,1.24,1.69,1.69,0,0,0,1.34,1.61A1.41,1.41,0,0,0,734,579,2.32,2.32,0,0,0,734.55,577.58Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.58,510.74a2.63,2.63,0,0,0-3.94-1.06,1.09,1.09,0,0,0,0,1.59,1.65,1.65,0,0,0,.42,1,7.67,7.67,0,0,0-.15,1,2.46,2.46,0,0,0,.77,2,1.56,1.56,0,0,0,2.19,0A4,4,0,0,0,715.58,510.74Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702,493a.89.89,0,0,0-1.2-.16l0,0,0,0h0a.43.43,0,0,0,0,.64.79.79,0,0,0,.14.18l.1.08h0l0,0a.53.53,0,0,1,.06.1h0a1.2,1.2,0,0,0,.13.36.62.62,0,0,0,1.07,0A1.09,1.09,0,0,0,702,493Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.78,540.06a4,4,0,0,0-2.1-3.2c-1.07-.45-2.34.56-1.67,1.7a4.09,4.09,0,0,1,.71,2.17c0,.94-.41,1.85-.32,2.78a1.51,1.51,0,0,0,2.8.71A6.77,6.77,0,0,0,746.78,540.06Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.18,525.1a1.3,1.3,0,0,0-.93,1.25,3.41,3.41,0,0,0,.37,1.37c.11.15.22.29.34.43-.11-.13-.1-.11,0,.06l.16.31.12.41,0,.12a1,1,0,0,0,0,.11c0,.08,0,.54,0,.21a3,3,0,0,0,0,1.29,1.82,1.82,0,0,0,3,.78C736.31,529.55,734.19,524,731.18,525.1Z",
    style: {
      fill: "#f9d2dd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "raspberry-3",
    "data-name": "raspberry"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.14,420.58a16.56,16.56,0,1,1-5.6-23l.33.2A16.55,16.55,0,0,1,789.14,420.58Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.14,420.58a16.57,16.57,0,0,1-17.1,7.51l-.31-.2a16.56,16.56,0,0,1,11.81-30.33l.33.2A16.55,16.55,0,0,1,789.14,420.58Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.47,428.12a16.56,16.56,0,1,1-5.59-23l.32.19A16.57,16.57,0,0,1,810.47,428.12Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.47,428.12a16.54,16.54,0,0,1-17.09,7.5l-.32-.19a16.56,16.56,0,0,1,11.82-30.33l.32.19A16.57,16.57,0,0,1,810.47,428.12Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821,444.93a16.57,16.57,0,1,1-5.6-23l.32.2A16.57,16.57,0,0,1,821,444.93Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821,444.93a16.57,16.57,0,0,1-17.1,7.51l-.32-.2a16.56,16.56,0,0,1,11.82-30.33l.32.2A16.57,16.57,0,0,1,821,444.93Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.55,466.28a16.56,16.56,0,1,1-2.76-23.53l.3.23A16.57,16.57,0,0,1,817.55,466.28Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.55,466.28a16.56,16.56,0,0,1-17.88,5.37l-.29-.23a16.56,16.56,0,0,1,15.41-28.67l.3.23A16.57,16.57,0,0,1,817.55,466.28Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.41,446.82a16.54,16.54,0,0,1-18,5,16.27,16.27,0,0,1-5.36-3,16.56,16.56,0,0,1,21-25.58l.3.25A16.55,16.55,0,0,1,744.41,446.82Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.41,446.82a16.54,16.54,0,0,1-18,5,3.36,3.36,0,0,1-.29-.24,16.56,16.56,0,0,1,16-28.36l.3.25A16.55,16.55,0,0,1,744.41,446.82Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.94,463a16.56,16.56,0,1,1-8.31-22.18l.35.15A16.56,16.56,0,0,1,758.94,463Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.94,463a16.56,16.56,0,0,1-16.07,9.5l-.34-.16a16.56,16.56,0,0,1,8.1-31.52l.35.15A16.56,16.56,0,0,1,758.94,463Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.87,482.81a16.56,16.56,0,1,1-12.16-20.33l.37.09A16.57,16.57,0,0,1,776.87,482.81Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.87,482.81A16.57,16.57,0,0,1,762.76,495l-.37-.09a16.57,16.57,0,0,1,2.32-32.47l.37.09A16.57,16.57,0,0,1,776.87,482.81Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.48,492.22a16.56,16.56,0,1,1-12.16-20.34l.37.1A16.57,16.57,0,0,1,804.48,492.22Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.48,492.22a16.57,16.57,0,0,1-14.11,12.23l-.37-.1a16.57,16.57,0,0,1,2.32-32.47l.37.1A16.57,16.57,0,0,1,804.48,492.22Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.32,428a16.57,16.57,0,1,1-5.6-23l.32.2A16.57,16.57,0,0,1,767.32,428Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.32,428a16.57,16.57,0,0,1-17.1,7.51l-.32-.2A16.56,16.56,0,0,1,761.72,405l.32.2A16.57,16.57,0,0,1,767.32,428Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.61,446.29a16.56,16.56,0,1,1-5.6-23l.33.2A16.55,16.55,0,0,1,774.61,446.29Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.61,446.29a16.55,16.55,0,0,1-17.09,7.51l-.32-.2A16.56,16.56,0,0,1,769,423.27l.33.2A16.55,16.55,0,0,1,774.61,446.29Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.24,465.76a16.56,16.56,0,0,0-10-21.2l-.36-.12a16.56,16.56,0,1,0,10.33,21.32Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.69,480.37a16.55,16.55,0,0,0-5.27-22.82l-.33-.2a16.56,16.56,0,1,0,5.6,23Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.28,438.66a16.56,16.56,0,1,1-5.6-23l.33.2A16.55,16.55,0,0,1,797.28,438.66Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.28,438.66a16.55,16.55,0,0,1-17.09,7.51l-.32-.19a16.57,16.57,0,0,1,11.81-30.34l.33.2A16.55,16.55,0,0,1,797.28,438.66Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.66,453.69a16.57,16.57,0,0,0-5.27-22.82l-.33-.2a16.57,16.57,0,1,0,5.6,23Z",
    style: {
      fill: "#e82849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.06,462a3.92,3.92,0,0,0-.68-2.38,16.21,16.21,0,0,0-1-1.89,7.92,7.92,0,0,0,3.19-4.3.39.39,0,0,0-.59-.38,19.54,19.54,0,0,0-1.9,2,15.36,15.36,0,0,0-1.71,2,.81.81,0,0,0-.73,1.1c.33.77.7,1.52,1,2.29s.45,1.61,1.08,2.09A.82.82,0,0,0,813.06,462Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.44,475.32a39.24,39.24,0,0,0-4.19-2.27,21.48,21.48,0,0,1-4.3-3.36,14.18,14.18,0,0,1-4.09-8.06,12.71,12.71,0,0,1,1.59-8.12c2.11-3.54,5.31-5.37,8.65-7.52a.82.82,0,0,0-.73-1.44c-3.85,1.38-8.29,3.8-10.69,7.2a14.35,14.35,0,0,0-2.38,10.19,17.74,17.74,0,0,0,4.68,9.78c2.55,2.76,6.89,5.77,10.8,5.66A1.18,1.18,0,0,0,771.44,475.32Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787,479.88c-.3-2.05-1.32-3.85-1.54-6a9.06,9.06,0,0,1,1.77-6.49,18.84,18.84,0,0,1,10.2-7.15c.68-.22.37-1.1-.24-1.12a13.76,13.76,0,0,0-3.37.32.87.87,0,0,0-.23-.43,26.24,26.24,0,0,0-2.92-2.28,14.54,14.54,0,0,1-2.83-3.18,15,15,0,0,1-2.5-7.81,15.26,15.26,0,0,1,2.18-8.23c1.66-2.7,4-4.37,6.48-6.19a1,1,0,0,0-.9-1.76c-6.15,2.15-10.41,9.51-10.54,15.79a17.38,17.38,0,0,0,2.56,9.31c1.19,2,3.32,4.65,5.69,5.75a17,17,0,0,0-7.33,6.06,11.38,11.38,0,0,0-1.83,7.74c.25,2.57.84,5.75,3.31,7.06A1.45,1.45,0,0,0,787,479.88Z",
    style: {
      fill: "#ce021b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.46,435.67c-.17-1.74-1.05-4.49-3.08-4.74a.86.86,0,0,0-1,.92c.22,1.46,1.28,2.5,1.34,4a5.1,5.1,0,0,1-.32,2.05c-.33.85-.72,1.25-.51,2.2a1.15,1.15,0,0,0,1.2.78C820.17,440.66,820.62,437.36,820.46,435.67Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.06,475.84a6.06,6.06,0,0,0-.27-5.66.76.76,0,0,0-1.37.3,13.32,13.32,0,0,1-1.35,5.38c-.83,1.53-2.34,2.72-2.38,4.52,0,.67.75,1,1.29.82C810,480.67,811.39,477.65,812.06,475.84Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811,415.59a3.63,3.63,0,0,0-.75-2.66c-.55-.68-1.66-1.33-2.45-.77a.72.72,0,0,0-.4,1.06,3.65,3.65,0,0,0,.59,1.07,1.25,1.25,0,0,1,.24.82,1.44,1.44,0,0,0,1.15,1.62A1.41,1.41,0,0,0,811,415.59Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.79,447.49c2-3.3,1-8.34-2.64-10.08a3.88,3.88,0,0,0-5.1,1.34,3.35,3.35,0,0,0-.47,2.31,3.81,3.81,0,0,0,1.14,1.84,3.66,3.66,0,0,1,.27,1.5c-.15,2-2.22,3.16-2.27,5.13a3,3,0,0,0,3.85,2.78C807.63,451.73,809.73,449.23,810.79,447.49Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778,458.09a1.44,1.44,0,0,0-.43-.21.89.89,0,0,0-.78-.16,1,1,0,0,0-.8,1.06v.11a1.65,1.65,0,0,0-.06.32s0,.14,0,.23,0,.18-.06.24-.16.34-.15.33a4.79,4.79,0,0,1-.35.38,1.25,1.25,0,0,0,1.66,1.83C778.18,461.47,779.42,459.17,778,458.09Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.09,491.79a1.49,1.49,0,0,0-.5-1.57,1.28,1.28,0,0,0-1.69,0,1.42,1.42,0,0,0-1,1.07,1.68,1.68,0,0,0,1,1.83,1.38,1.38,0,0,0,1.35-.11A2.36,2.36,0,0,0,801.09,491.79Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.07,422.57a2.62,2.62,0,0,0-3.66-1.78,1.08,1.08,0,0,0-.33,1.55,1.65,1.65,0,0,0,.23,1,5.44,5.44,0,0,0-.32.91,2.43,2.43,0,0,0,.36,2.11,1.57,1.57,0,0,0,2.16.4A4,4,0,0,0,795.07,422.57Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.1,402.56a.9.9,0,0,0-1.15-.39l0,0h0a.44.44,0,0,0-.16.61,1.36,1.36,0,0,0,.1.21l.09.09v0l0,0a.45.45,0,0,0,0,.11s0,0,0,0a1.51,1.51,0,0,0,.06.37.62.62,0,0,0,1.05.19A1.1,1.1,0,0,0,785.1,402.56Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.18,457.25a4,4,0,0,0-1.46-3.54,1.24,1.24,0,0,0-2,1.36,4.15,4.15,0,0,1,.28,2.26c-.17.93-.76,1.75-.84,2.68a1.51,1.51,0,0,0,2.62,1.22A6.81,6.81,0,0,0,820.18,457.25Z",
    style: {
      fill: "#f490a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.69,439.62a1.29,1.29,0,0,0-1.15,1.05,3.19,3.19,0,0,0,.11,1.41,4.59,4.59,0,0,0,.24.5c-.07-.16-.07-.14,0,.06a2.43,2.43,0,0,0,.09.33c0,.14,0,.28,0,.42a.7.7,0,0,0,0,.13.41.41,0,0,0,0,.1c0,.08-.13.53,0,.22a2.89,2.89,0,0,0-.22,1.27,1.82,1.82,0,0,0,2.81,1.33C811.89,445,810.84,439.12,807.69,439.62Z",
    style: {
      fill: "#f9d2dd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "banana"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.39,844.06c-.19,30.61-89.9,51.12-98.7,53.07-146.48,32.49-269.32-68-283.29-79.79,0,0-102.8-86.46-124.52-225.39-11-70.11,6.13-106.91,12-118.28,2.9-5.63,36.81-70.09,71.88-66.56,57.69,5.8,18.51,189.85,133.48,301.54C436.77,819.93,611.65,801.32,611.39,844.06Z",
    style: {
      fill: "#fcee21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.69,897.13c-146.49,32.48-269.33-68-283.29-79.79,0,0-102.8-86.45-124.52-225.39-10.95-70.12,6.13-106.9,12-118.28,2.63-5.12,31-59.06,62.56-66a4.92,4.92,0,0,1,.66-.16c-.23.32-.47.62-.69.93a238.25,238.25,0,0,0-18,29c-5.85,11.38-22.93,48.16-12,118.28C171.14,694.72,274,781.19,274,781.19c14,11.75,136.8,112.27,283.29,79.79,4.5-1,30.1-6.83,54.1-16.39C610.15,874.89,521.43,895.21,512.69,897.13Z",
    style: {
      fill: "#efd800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.35,844.59c-24,9.56-49.6,15.41-54.1,16.39-146.49,32.48-269.33-68-283.29-79.79,0,0-102.82-86.47-124.52-225.39-10.95-70.12,6.13-106.9,12-118.28a238.25,238.25,0,0,1,18-29c.22-.31.46-.61.69-.93a.53.53,0,0,1,.14,0c2.34,9.44,5.85,23.73,9.9,41.15,16.1,69.32,23.61,113.75,27.07,130.17,10.17,48.52,40.76,119.72,96.46,168.8,66.94,59,156.27,73.78,273.51,93.21,2.2.37,4.32.71,6.33,1,6.53,1.05,12.1,1.88,16.37,2.48C610.38,844.46,610.87,844.53,611.35,844.59Z",
    style: {
      fill: "#fcee21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.38,844c-.51.15-1,.25-1.52.38-9.26,2.36-16.18,3.78-18.32,4.19-147.1,29.51-267.9-73.46-281.63-85.49-92.16-90.7-119.66-177-129.46-222.65-8.57-40-14.72-100.89-1.08-131.1.26-.61.55-1.2.85-1.78a29.72,29.72,0,0,1,8.52-.43c57.68,5.8,18.5,189.85,133.48,301.54C433,816.29,600.18,802.42,610.85,840A14.86,14.86,0,0,1,611.38,844Z",
    style: {
      fill: "#efd800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.85,840c-5,.67-10.8,1.31-17.36,1.87C542,846.33,445.11,844.62,353.17,784,225.07,699.52,196.51,560,188,518.52a449.19,449.19,0,0,1-8.65-109.2c0-.29,0-.55,0-.84a4.77,4.77,0,0,0,0-.77,4.92,4.92,0,0,1,.66-.16.53.53,0,0,1,.14,0,29.72,29.72,0,0,1,8.52-.43c57.68,5.8,18.5,189.85,133.48,301.54C433,816.29,600.18,802.42,610.85,840Z",
    style: {
      fill: "#fcee21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,427.53c4.8,10.59,7.61,21.75,9.57,33.19,1.83,10.7,1.72,22,4.21,32.54.46,1.92,3.7,2.42,3.81,0,.54-11.22-1.81-23.39-4-34.38a125.83,125.83,0,0,0-11-32.44C202.81,424.86,200.19,425.83,201,427.53Z",
    style: {
      fill: "#efd800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.09,774.7c-9.09-5.26-19.21-8.7-28.39-14a234.39,234.39,0,0,1-28-19c-17.67-13.86-33.91-29.71-49.48-45.87-1.55-1.61-4.41.31-2.89,2.14a351.9,351.9,0,0,0,50.1,49c16,12.88,36.47,29.16,57.28,32.67C410.86,780.17,411.45,776.06,409.09,774.7Z",
    style: {
      fill: "#efd800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,445.49a14.77,14.77,0,0,1-6.46-19.8,146.74,146.74,0,0,1,19.38-51.75A144.45,144.45,0,0,1,209,348.45a15.07,15.07,0,0,1,8.56-7.32c.57-.18,6.19-1.93,11.23.86,5.87,3.23,8.87,11.43,6.46,19.79a166,166,0,0,0-18.29,24.49A167.76,167.76,0,0,0,196,439C190.67,445.9,182.18,448.52,176.2,445.49Z",
    style: {
      fill: "#fcee21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.89,824.61a179.56,179.56,0,0,0-36.74-7.24.84.84,0,0,0-.23,1.66,301.85,301.85,0,0,1,38.29,9.8c10.82,3.59,21.17,9.68,32.11,12.58,1.09.29,1.59-1.3.82-1.92C588.89,832,575.12,828.08,563.89,824.61Z",
    style: {
      fill: "#efd800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.05,340.48l-.2.14c-2.48,1.93-1.47,4.61-1.34,7.38.11,2.11.68,2.79-.29,4.92-2.2,4.9-8.05,9.54-11.47,13.72a215.62,215.62,0,0,0-22.5,33.4,47.17,47.17,0,0,1,4.71.85c3.43.84,3.46,4.73,1.52,6.64l-.51-.1-.89-.15c-.45-.08-.89-.13-1.34-.18a31.83,31.83,0,0,0-4.14-.09c-.55,0-1.1.08-1.65.14s-.85.1-1.28.16-1,.14-1.45.23a.2.2,0,0,0-.14,0l-.41.08-.25.08a37,37,0,0,0-6,1.87l-1.34.56c.45-.22.9-.41,1.35-.59A144.13,144.13,0,0,1,209,348.44a15.07,15.07,0,0,1,8.56-7.31A15.72,15.72,0,0,1,221.05,340.48Z",
    style: {
      fill: "#a67c52",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.49,861.13l-.33.38c-.77.83-1.59,1.67-2.47,2.49-.44.41-.9.82-1.36,1.21a71.13,71.13,0,0,1-8.78,6.42c-.58.38-1.2.74-1.8,1.1s-1.23.74-1.86,1.11c-1.56.89-3.17,1.78-4.84,2.63-1,.52-2,1-3,1.53L579,879c-4.49,2.15-9.22,4.13-14,6-1.28.5-2.57,1-3.85,1.46l-.55.21c-1.47.53-2.93,1.07-4.38,1.57l-4,1.39c-3,1-6,2-8.89,2.87-1.34.41-2.67.82-4,1.2-5.55,1.65-10.63,3-14.85,4.13l-2.26.57-1.43.36-1.26.31-3.6.86c-.42.11-.82.18-1.18.26l-.88.21-.57.12c-.17,0-.33.08-.47.11a271.47,271.47,0,0,1-65.52,6.34c-1.29,0-2.57-.05-3.85-.11-.86,0-1.72-.05-2.58-.11s-1.75-.06-2.62-.12-1.8-.1-2.68-.16c-.65,0-1.29-.08-1.94-.13l-3.55-.27c-1.37-.11-2.74-.23-4.09-.36l-4-.42c-.71-.08-1.42-.16-2.13-.26q-4.43-.5-8.8-1.16c-1.53-.22-3.06-.46-4.57-.71-1.33-.21-2.65-.44-4-.68l-1-.17c-1.05-.19-2.09-.38-3.13-.59-.7-.12-1.39-.27-2.07-.39l-2.36-.49c-.89-.17-1.75-.35-2.62-.55-1.07-.22-2.16-.46-3.23-.71-1.31-.29-2.62-.59-3.91-.9-1.45-.33-2.9-.69-4.34-1.06-3.28-.82-6.52-1.7-9.72-2.6l-1.09-.31c-1.25-.35-2.48-.71-3.71-1.09-1.46-.44-2.93-.88-4.4-1.36-.33-.09-.66-.2-1-.31-1.34-.41-2.66-.85-4-1.29s-2.5-.82-3.75-1.27c-11.54-4-22.5-8.35-32.74-13-1.19-.52-2.37-1.07-3.53-1.6-2.34-1.08-4.64-2.16-6.89-3.27-2.59-1.26-5.11-2.52-7.59-3.78-3.72-1.91-7.31-3.82-10.8-5.72-2.31-1.3-4.57-2.56-6.77-3.82q-1.67-.95-3.27-1.89c-2.14-1.26-4.24-2.52-6.27-3.75q-4.56-2.79-8.75-5.47-2.77-1.8-5.36-3.52c-5.19-3.45-9.79-6.68-13.8-9.6-1-.72-2-1.45-2.88-2.13-1.53-1.13-3-2.22-4.27-3.23-1.06-.8-2-1.58-2.95-2.28l-3.6-2.87-1.82-1.5-.19-.16-1.17-1S126.73,734.35,105,595.41c-11-70.1,6.14-106.9,12-118.26.41-.81,1.45-2.79,3-5.62.27-.5.57-1,.87-1.56.41-.69.81-1.42,1.27-2.19.21-.34.41-.69.62-1,1.89-3.19,4.19-6.91,6.82-10.88l.9-1.34c6-9,13.7-19,22.36-27.26,1.73-1.64,3.5-3.22,5.29-4.7.9-.74,1.82-1.45,2.73-2.14s1.84-1.36,2.78-2,1.87-1.23,2.8-1.79,1.91-1.11,2.85-1.61a5.1,5.1,0,0,1,.57-.29,4.13,4.13,0,0,0,1.85,1,182.58,182.58,0,0,0-17.33,22.15l-.9,1.34c-2.63,4-4.93,7.7-6.82,10.88l-.62,1.06c-.46.77-.87,1.5-1.28,2.19-.3.53-.59,1.05-.86,1.56-1.59,2.82-2.64,4.81-3,5.61-5.84,11.37-22.93,48.16-12,118.27,21.71,138.93,124.53,225.39,124.53,225.39l1.17,1c.06,0,.12.11.19.15.53.45,1.15.95,1.82,1.5q1.56,1.26,3.6,2.87c.91.73,1.89,1.48,2.95,2.29,1.31,1,2.74,2.09,4.27,3.23l2.88,2.13c4,2.91,8.61,6.14,13.8,9.6,1.72,1.15,3.51,2.31,5.36,3.51q4.18,2.67,8.75,5.47c2,1.25,4.11,2.49,6.27,3.76q1.61.94,3.27,1.89,3.3,1.89,6.77,3.81c3.49,1.91,7.08,3.82,10.8,5.72,2.48,1.28,5,2.54,7.59,3.79q3.38,1.65,6.89,3.26c1.16.54,2.34,1.09,3.53,1.61,10.24,4.63,21.2,9,32.74,13,1.25.44,2.49.85,3.75,1.26s2.65.88,4,1.29l1,.32c1.47.47,2.94.91,4.4,1.35,1.23.38,2.46.75,3.71,1.09l1.08.32c3.2.9,6.45,1.78,9.73,2.6,1.44.36,2.89.72,4.34,1.06,1.29.31,2.6.61,3.91.89,1.07.26,2.16.49,3.23.71.87.21,1.73.38,2.62.56s1.57.33,2.36.48l2.07.4,3.13.58c.33.06.68.13,1,.17,1.31.24,2.63.48,4,.68,1.51.25,3,.49,4.57.71,2.92.44,5.85.84,8.8,1.17l2.13.25c1.33.16,2.68.3,4,.43s2.72.25,4.09.36l3.55.27c.65,0,1.29.09,1.94.12.88.07,1.78.13,2.68.16s1.75.11,2.62.13,1.72.09,2.58.11c1.28.06,2.56.09,3.85.11A272.48,272.48,0,0,0,536.73,884c.14,0,.3-.06.47-.11l.57-.13.88-.2c.36-.08.76-.16,1.18-.27l3.6-.85,1.26-.32,1.43-.36,2.26-.57c4.22-1.1,9.3-2.47,14.85-4.13,1.29-.37,2.62-.78,4-1.19,2.88-.89,5.86-1.85,8.89-2.87l4-1.39c1.45-.51,2.91-1,4.38-1.58.19-.08.36-.14.55-.2,1.28-.48,2.57-1,3.85-1.47,4.76-1.84,9.49-3.83,14-6l2.07-1Z",
    style: {
      fill: "#a67c52",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,348.7a3.59,3.59,0,0,0-1.28-.84c-2-1.93-6.23-1.11-6.24,2.5,0,2-.36,4.44.19,6.43.66,2.4,2.67,4.48,5.34,4.06C233.31,360,233.06,351.73,230,348.7Z",
    style: {
      fill: "#fffbe9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.17,616.66c-1.61-7.95-5.5-15.53-8.24-23.15-3-8.21-5.72-16.48-8.06-24.88-4.5-16.08-8.84-32.81-11.36-49.32-.17-1.07-1.93-.82-1.89.25.75,17.46,2.23,33.92,6.6,50.9,4,15.6,8.49,35.08,18.45,48.09C249.33,620.72,252.75,619.54,252.17,616.66Z",
    style: {
      fill: "#fffbe9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.15,807.57c-6.81-2.18-14.3-2.06-21.32-3.66-6.32-1.44-12.54-4.07-19-4.34A2.64,2.64,0,0,0,474,804c5.29,4.93,13.05,7,19.95,8.69,7.08,1.7,15.06,3.48,22.25,2C519.91,813.91,519.41,808.61,516.15,807.57Z",
    style: {
      fill: "#fffbe9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.44,411.31C642.87,363.94,736.6,311,692.69,220.76c0,0,20.31,16.78,23,26.74,23.15-43.83-2.69-59-18.84-77.88,0,0,39.6,6.53,48.8,35.66,17.14-54.62-25.89-69.09-54.35-69.8,44.16-5.24,68.82,11.93,77.6,18.53,8.52,6.39,18.29-20.35,19.53-61-1.29,29.11,7.73,67.4-17.71,85.35L814.3,156.8c-4.49,20.22-60,46.26-60.36,64.81,22.5-9.69,57.35-33.78,68.15-41-24,22.64-45.66,41.22-77,70.79,15.11.27,27.09-4.16,48.61-20.57C687.5,332.08,660.29,389.91,554.44,411.31Z",
    style: {
      fill: "#217821"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.57,410.42c61.16-47,125.92-99.7,92.7-194.5,0,0,14.73,17.94,16.92,28.36,15.23-44.95-3.37-61.37-15.23-81.38,0,0,28.08,7.78,35.29,38.27,10.72-56.31-20-72.42-40.06-73.88,31-4.33,48.81,14.12,55.17,21.19a3.57,3.57,0,0,0,1.89,1.05c8,1.8,19.45-24.36,20.32-24,.61.29-4.55,13-20.32,48.23l30.15-21.29c-2.66,20.89-41.13,46.56-40.93,65.82,15.62-9.51,39.59-33.66,47-40.88-16.36,22.92-31.16,41.68-52.49,71.61,10.66.67,19-3.64,33.76-20.14a1003.69,1003.69,0,0,0-57.88,84.63c-11.66,19.11-15.22,26.43-23.57,37.21C624.94,382.27,593.28,399.94,566.57,410.42Z",
    style: {
      fill: "#217821"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.35,433.86C658.75,408,656.5,283.1,750,254a.56.56,0,0,0-.14-1.1c-6.22-.29-20-.57-28,2a.57.57,0,0,1-.62-.89c26.91-35.72,50.21-31.23,72.59-32.63a.57.57,0,0,0,.29-1c-5.5-3.82-23.56-16.13-47.71-7a.56.56,0,0,1-.6-.93c35.93-35.61,64.25-25.16,78.28-11.29a.56.56,0,0,0,.87-.7c-14.55-24-37.71-27.61-46.63-28.69-9.16-1.1,9.8-22,44.44-46.14-23.23,16.5-57.41,32.56-65.16,55a.56.56,0,0,1-1.09-.2l.09-31.23a.57.57,0,0,0-1-.39c-14.26,14.9-13.86,58-28.5,69.7a.57.57,0,0,1-.93-.39c-.76-15.49,3.2-40.82,5.45-54.51a.56.56,0,0,0-1.09-.26c-8.23,23.79-14.88,45.54-26,77a.57.57,0,0,1-1,.16c-5.24-7-6.74-14.91-4-30.23,0-.2-.59-.36-1.09-.29-5.27.72-4.43,35.08-4.41,38.66.12,21.91-24,71.22-117.85,185.29Z",
    style: {
      fill: "#00960e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.5,660.8c15.13-14.38,20-29.84,25.12-45.28,13.58-25.59,31.21-49.06,59.48-66.92,22-35.51,24.57-62.51,77.44-111.47a291,291,0,0,1,50.18-66.8c21.52-21.4,65.79-24.24,83.14-5.46,1.42,1.53,7.84,8.82,8.84,25.58,2.89,48.17-44.22,86.18-54.5,94.15-4.11,3.49-33.07,28.07-49.76,39.56-2.45,1.68-4.6,3.11-6.49,4.36-26.49,17.43-35.45,18.62-46.72,25.56a79.92,79.92,0,0,0-13.33,10.16c-5.76,5.36-6.78,7.81-10.93,12.33-8.23,9-13.15,9-28.78,19.92a198.5,198.5,0,0,0-16.79,13.09c-5.93,7.35-18.79,22.77-31.09,32.92-7,5.77-11.74,9.76-16.12,12.67a128.47,128.47,0,0,1-15,8.62l-11.4,3A3.5,3.5,0,0,1,348.5,660.8Z",
    style: {
      fill: "#fb9a33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.47,411.38l20.43,4C546.88,408.47,539.17,404.5,530.47,411.38Z",
    style: {
      fill: "#fff",
      opacity: 0.3589000105857849,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.55,450.39l8.49,22.7C606.38,462.33,606.39,451.9,597.55,450.39Z",
    style: {
      fill: "#fff",
      opacity: 0.3589000105857849,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.44,382.52l9.28,6.18,8.71,10.05C614.78,389,610,379.78,601.44,382.52Z",
    style: {
      fill: "#fff",
      opacity: 0.3589000105857849,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.36,548l8.66,4.72c3.14,1.7,5.92-3,2.83-4.78-2.19-1.27-5.7-1.51-11.49.06Z",
    style: {
      fill: "#fff",
      opacity: 0.3589000105857849,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.68,492.56l13.27,15C554.88,499.72,555.26,492.2,540.68,492.56Z",
    style: {
      fill: "#fff",
      opacity: 0.3589000105857849,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.45,482.93l13.77,6.18C495.65,481,492.87,473.58,484.45,482.93Z",
    style: {
      fill: "#fff",
      opacity: 0.3589000105857849,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.86,611.85l13.87,4.74C390.2,612.05,388.36,607.82,377.86,611.85Z",
    style: {
      fill: "#fff",
      opacity: 0.3589000105857849,
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetables);
export default __webpack_public_path__ + "static/media/vegetables.847f294477d1352430c5968ca8bd902c.svg";
export { ForwardRef as ReactComponent };